<p-dialog [(visible)]="visible" [style]="{width: widthSize}" [maximizable]="true">
    <app-grid #grid [columnDefs]="columsDef" [rowData]="rowData" [rowSelection]="'multiple'"
        [isProjectOwnershipValid]="isProjectOwnershipValid" [suppressRowClickSelection]="true"
        (calendarSelectionChangeEvent)="onCalendarSelectionChanged($event)" [pagination]="false"
        (onInputNumberChanged)="onJulianDayChanged($event)"
        (onCheckboxSelectedEvent)="onCheckboxSelectionChanged($event)"
        (onChangeAllMitigationSelectionEvent)="onCheckboxAllSelectionChanged($event)"></app-grid>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="closeDialog()" label="Save" [disabled]="!isProjectOwnershipValid"
            pAutoFocus [autofocus]="true"></p-button>
    </ng-template>
</p-dialog>